/* eslint-disable no-void */

import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api; bearer: string };

type HookTuple = [
  response: vp.AccountTransactions,
  fetchData: (params: vp.AccountTransactionsRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchAccountTransactions: ApiHook = ({ api, bearer }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Common' });
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [response, setResponse] = useState<vp.AccountTransactions>({
    Success: false,
    ErrorMessage: '',
  });
  const [params, setParams] = useState<vp.AccountTransactionsRequest>({ StartDateTime: '', EndDateTime: '' });
  const [shouldFetchData, setShouldFetchData] = useState(false);
  const source = axios.CancelToken.source();

  useEffect(() => {
    if (!shouldFetchData) return () => {};

    const loadData = async () => {
      setDataFetchingInfo(true, `${t('Loading')}`, 'fullScreen');
      const accountTransactionsResponse = await api.fetchAccountTransactions(params, bearer, source);
      setResponse(accountTransactionsResponse);

      setDataFetchingInfo(false);
    };

    if (shouldFetchData) void loadData();
    setShouldFetchData(false);

    return () => {
      source.cancel();
    };
  }, [shouldFetchData]);

  return [
    response,
    (_params: vp.AccountTransactionsRequest) => {
      setParams(_params);
      setShouldFetchData(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldFetchData(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchAccountTransactions);
